import React, { useState, useMemo, useEffect } from 'react';
import './PopularSearch.css';

interface SearchCategory {
  heading: string;
  links: { label: string; href: string }[];
}

const searchData: SearchCategory[] = [
  {
    heading: 'Hex Nuts',
    links: [
      { label: 'Hex Nuts Under Rs. 500', href: '/alp/hex-nuts-under-price-500' },
      { label: 'Hex Nuts Above Rs. 10000', href: '/alp/hex-nuts-above-10000' },
      { label: 'Hex Nuts Under Rs. 10000', href: '/alp/hex-nuts-under-10000' },
      { label: 'Hex Nuts Under Rs. 5000', href: '/alp/hex-nuts-under-5000' },
      { label: 'Hex Nuts Under Rs. 2500', href: '/alp/hex-nuts-under-2000' },
      { label: 'Hex Nuts Under Rs. 1000', href: '/alp/hex-nuts-under-1000' },
    ],
  },
  {
    heading: 'Sledge Hammers',
    links: [
      { label: 'Sledge Hammers Under Rs. 500', href: '/alp/sledge-hammers-under-500' },
      { label: 'Sledge Hammers Under Rs. 1000', href: '/alp/sledge-hammers-under-1000' },
      { label: 'Sledge Hammers Under Rs. 2000', href: '/alp/sledge-hammers-under-price-2000' },
      { label: 'Sledge Hammers Under Rs. 5000', href: '/alp/sledge-hammers-under-price-5000' },
      { label: 'Sledge Hammers Under Rs. 10000', href: '/alp/sledge-hammers-under-price-10000' },
    ],
  },
  {
    heading: 'LED',
    links: [
      { label: 'Square Led Lights', href: '/alp/square-led-lights' },
      { label: '6000K Led Lights', href: '/alp/6000k-led-lights' },
      { label: 'Round Led Lights', href: '/alp/round-led-lights' },
      { label: 'Led Lights Under Rs. 500', href: '/alp/led-lights-under-500' },
      { label: 'Led Lights Under Rs. 1000', href: '/alp/led-lights-under-1000' },
      { label: 'Led Lights Under Rs. 2000', href: '/alp/led-lights-under-2000' },
      { label: 'Led Lights Under Rs. 5000', href: '/alp/led-lights-under-5000' },
      { label: 'Led Lights Under Rs. 10000', href: '/alp/led-lights-under-10000' },
      { label: 'Led Lights Above Rs. 10000', href: '/alp/led-lights-above-10000' },
    ],
  },
  {
    heading: 'Laptops',
    links: [
      { label: 'Hp Laptops Under Rs. 50000', href: '/alp/hp-laptops-under-50000' },
      { label: 'Laptops Under Rs. 50000', href: '/alp/laptops-under-50000' },
      { label: '14 Inch Laptops', href: '/alp/14-inch-laptops' },
      { label: '13 Inch Laptops', href: '/alp/13-inch-laptops' },
      { label: '16 Inch Laptops', href: '/alp/16-inch-laptops' },
      { label: '512 GB SSD Laptops', href: '/alp/512-gb-ssd-laptops' },
      { label: '1 TB SSD Laptops', href: '/alp/1-tb-ssd-laptops' },
      { label: '256 GB SSD Laptops', href: '/alp/256-gb-ssd-laptops' },
      { label: '8GB RAM Laptops', href: '/alp/8gb-ram-laptops' },
      { label: '16GB RAM Laptops', href: '/alp/16gb-ram-laptops' },
      { label: 'Gaming Laptops', href: '/alp/gaming-laptops' },
      { label: 'Windows Laptops', href: '/alp/windows-laptops' },
    ],
  },
  {
    heading: 'Air Conditioners',
    links: [
      { label: '1.5 Ton AC', href: '/alp/1-5-ton-ac' },
      { label: '1 Ton AC', href: '/alp/1-ton-ac' },
      { label: '2 Ton AC', href: '/alp/2-ton-ac' },
      { label: 'AC Under Rs. 25000', href: '/alp/ac-under-25000' },
      { label: 'AC Under Rs. 30000', href: '/alp/ac-under-30000' },
      { label: '5 Star AC', href: '/alp/5-star-ac-air-conditioners' },
      { label: '3 Star ACs', href: '/alp/3-star-ac' },
      { label: 'Voltas AC 1.5 Ton', href: '/alp/voltas-ac-1-5-ton' },
      { label: 'LG AC 1.5 Ton', href: '/alp/lg-ac-1-5-ton' },
    ],
  },
  {
    heading: 'Compressors',
    links: [
      { label: '2HP Air Compressors', href: '/alp/2hp-air-compressor' },
      { label: '1HP Air Compressors', href: '/alp/1hp-air-compressor' },
      { label: 'Mini Air Compressors', href: '/alp/mini-air-compressors' },
      { label: 'Oil Free Air Compressors', href: '/alp/oil-free-air-compressors' },
      { label: '50 Litre Air Compressors', href: '/alp/50-litre-air-compressors' },
      { label: 'Single Phase Air Compressors', href: '/alp/single-phase-air-compressors' },
      { label: 'Air Compressors Under Rs. 10000', href: '/alp/air-compressors-under-10000' },
    ],
  },
  {
    heading: 'Batteries',
    links: [
      { label: 'Tubular Batteries', href: '/alp/tubular-batteries' },
      { label: 'Car Batteries', href: '/alp/car-batteries' },
      { label: 'Rechargeable Batteries', href: '/alp/rechargeable-batteries' },
      { label: 'Inverter Batteries', href: '/alp/inverter-batteries' },
      { label: 'Batteries Under Rs. 1000', href: '/alp/batteries-under-1000' },
      { label: 'Batteries Under Rs. 5000', href: '/alp/batteries-under-5000' },
      { label: 'Bike Batteries', href: '/alp/bike-batteries' },
    ],
  },
  {
    heading: 'Smartphones',
    links: [
      { label: 'Smartphones Under Rs. 5000', href: '/alp/smartphones-under-5000' },
      { label: '5G Mobile Phones', href: '/alp/5g-mobile-phones' },
      { label: 'Android Phones', href: '/alp/android-phones' },
      { label: 'Apple iPhone', href: '/alp/apple-iphone' },
      { label: '4G Mobile Phones', href: '/alp/4g-mobile-phones' },
      { label: '128 GB Mobile Phones', href: '/alp/128-gb-mobile-phones' },
      { label: 'Samsung 5G Mobiles', href: '/alp/samsung-5g-mobile-phones' },
    ],
  },
  {
    heading: 'Pumps',
    links: [
      { label: '1 HP Water Pumps', href: '/alp/1-hp-water-pumps' },
      { label: '2 HP Water Pumps', href: '/alp/2-hp-water-pumps' },
      { label: '5 HP Water Pumps', href: '/alp/5-hp-water-pumps' },
      { label: 'Single Phase Water Pumps', href: '/alp/single-phase-water-pumps' },
      { label: 'Stainless Steel Water Pumps', href: '/alp/stainless-steel-water-pumps' },
      { label: 'Water Pumps For Home', href: '/alp/water-pumps-for-home' },
    ],
  },
  {
    heading: 'Ball Bearings',
    links: [
      { label: 'Deep Groove Ball Bearings', href: '/alp/deep-groove-ball-bearings' },
      { label: 'Angular Contact Ball Bearings', href: '/alp/angular-contact-ball-bearings' },
      { label: 'Thrust Ball Bearings', href: '/alp/thrust-ball-bearings' },
      { label: 'Ball Bearings Under Rs. 500', href: '/alp/ball-bearings-under-500' },
      { label: 'Ball Bearings Under Rs. 1000', href: '/alp/ball-bearings-under-1000' },
      { label: 'Ball Bearings Above Rs. 10000', href: '/alp/ball-bearings-above-10000' },
    ],
  },
  {
    heading: 'Wrenches',
    links: [
      { label: 'Wrenches Under Rs. 500', href: '/alp/wrenches-under-500' },
      { label: 'Wrenches Under Rs. 1000', href: '/alp/wrenches-under-1000' },
      { label: 'Wrenches Under Rs. 2000', href: '/alp/wrenches-under-2000' },
      { label: 'Wrenches Under Rs. 5000', href: '/alp/wrenches-under-5000' },
      { label: 'Wrenches Under Rs. 10000', href: '/alp/wrenches-under-10000' },
      { label: 'Wrenches Above Rs. 10000', href: '/alp/wrenches-above-10000' },
    ],
  },
  {
    heading: 'Safety Jackets',
    links: [
      { label: 'Orange Safety Jackets', href: '/alp/orange-safety-jackets' },
      { label: 'Polyester Safety Jackets', href: '/alp/polyester-safety-jackets' },
      { label: 'Yellow Safety Jackets', href: '/alp/yellow-safety-jackets' },
      { label: 'Safety Jackets Under Rs. 500', href: '/alp/safety-jackets-under-500' },
      { label: 'Safety Jackets Under Rs. 1000', href: '/alp/safety-jackets-under-1000' },
    ],
  },
  {
    heading: 'Respiratory Masks',
    links: [
      { label: 'N95 Respiratory Masks', href: '/alp/n95-respiratory-masks' },
      { label: 'Non Woven Respiratory Masks', href: '/alp/non-woven-respiratory-masks' },
      { label: 'Flat Fold Face Masks', href: '/alp/flat-fold-face-masks' },
      { label: 'Respiratory Masks Under Rs. 500', href: '/alp/respiratory-masks-under-500' },
      { label: 'Respiratory Masks Under Rs. 1000', href: '/alp/respiratory-masks-under-1000' },
    ],
  },
  {
    heading: 'Grinding Wheels',
    links: [
      { label: 'Grinding Wheels Under Rs. 500', href: '/alp/grinding-wheels-under-500' },
      { label: 'Grinding Wheels Under Rs. 1000', href: '/alp/grinding-wheels-under-1000' },
      { label: 'Grinding Wheels Under Rs. 2000', href: '/alp/grinding-wheels-under-2000' },
      { label: 'Grinding Wheels Under Rs. 5000', href: '/alp/grinding-wheels-under-price-5000' },
    ],
  },
  {
    heading: 'Padlocks',
    links: [
      { label: 'Brass Padlocks', href: '/alp/brass-padlocks' },
      { label: 'Stainless Steel Padlocks', href: '/alp/stainless-steel-padlocks' },
      { label: 'Round Padlocks', href: '/alp/round-padlocks' },
      { label: 'Padlocks Under Rs. 500', href: '/alp/padlocks-under-500' },
      { label: 'Padlocks Under Rs. 1000', href: '/alp/padlocks-under-1000' },
    ],
  },
  {
    heading: 'Microwave Ovens',
    links: [
      { label: 'Convection Microwave Ovens', href: '/alp/convection-microwave-ovens' },
      { label: '20 Litre Microwave Ovens', href: '/alp/20-litre-microwave-ovens' },
      { label: '23 Litre Microwave Ovens', href: '/alp/23-litre-microwave-ovens' },
      { label: 'Microwave Ovens Under Rs. 10000', href: '/alp/microwave-ovens-under-10000' },
      { label: 'Microwave Ovens Above Rs. 10000', href: '/alp/microwave-ovens-above-10000' },
    ],
  },
  {
    heading: 'Door Locks',
    links: [
      { label: 'Stainless Steel Door Locks', href: '/alp/stainless-steel-door-locks' },
      { label: '6 Lever Door Locks', href: '/alp/6-lever-door-locks' },
      { label: 'Iron Door Locks', href: '/alp/iron-door-locks' },
      { label: 'Door Locks Under Rs. 500', href: '/alp/door-locks-under-500' },
      { label: 'Door Locks Under Rs. 1000', href: '/alp/door-locks-under-1000' },
      { label: 'Door Locks Under Rs. 2000', href: '/alp/door-locks-under-2000' },
    ],
  },
  {
    heading: 'Headphones & Earphones',
    links: [
      { label: 'Bluetooth Headphones', href: '/alp/bluetooth-headphones-earphones' },
      { label: 'Wired Headphones', href: '/alp/wired-headphones-earphones' },
      { label: 'Noise Cancelling Headphones', href: '/alp/noise-cancelling-headphones' },
      { label: 'Gaming Headphones', href: '/alp/gaming-headphones' },
      { label: 'Headphones Under Rs. 500', href: '/alp/headphones-under-500' },
      { label: 'Headphones Under Rs. 1000', href: '/alp/headphones-under-1000' },
    ],
  },
  {
    heading: 'Measuring Tools',
    links: [
      { label: 'Measuring Tools Under Rs. 500', href: '/alp/measuring-tools-under-price-500' },
      { label: 'Measuring Tools Under Rs. 1000', href: '/alp/measuring-tools-under-1000' },
      { label: 'Measuring Tools Under Rs. 5000', href: '/alp/measuring-tools-under-5000' },
      { label: 'Measuring Tools Above Rs. 10000', href: '/alp/measuring-tools-above-10000' },
    ],
  },
  {
    heading: 'Packaging Tapes',
    links: [
      { label: 'Transparent Packaging Tapes', href: '/alp/transparent-packaging-tapes' },
      { label: 'Packaging Tapes Under Rs. 500', href: '/alp/packaging-tapes-under-500' },
      { label: 'Packaging Tapes Under Rs. 1000', href: '/alp/packaging-tapes-under-1000' },
      { label: 'Packaging Tapes Under Rs. 2000', href: '/alp/packaging-tapes-under-2000' },
    ],
  },
  {
    heading: 'Solid State Drives',
    links: [
      { label: '256 GB SSD', href: '/alp/256-gb-ssd' },
      { label: '1 TB SSD', href: '/alp/1-tb-ssd' },
      { label: '500 GB SSD', href: '/alp/500-gb-ssd' },
      { label: 'SSDs Under Rs. 2000', href: '/alp/solid-state-drives-under-2000' },
      { label: 'SSDs Under Rs. 5000', href: '/alp/solid-state-drives-under-5000' },
    ],
  },
  {
    heading: 'Calipers',
    links: [
      { label: 'Stainless Steel Calipers', href: '/alp/stainless-steel-calipers' },
      { label: '150 MM Vernier Calipers', href: '/alp/150-mm-vernier-calipers' },
      { label: '300 MM Vernier Calipers', href: '/alp/300-mm-vernier-calipers' },
      { label: 'Calipers Under Rs. 500', href: '/alp/calipers-under-500' },
      { label: 'Calipers Under Rs. 1000', href: '/alp/calipers-under-1000' },
      { label: 'Calipers Above Rs. 10000', href: '/alp/calipers-above-10000' },
    ],
  },
  {
    heading: 'Torque Wrenches',
    links: [
      { label: 'Torque Wrenches Under Rs. 5000', href: '/alp/torque-wrenches-under-5000' },
      { label: 'Torque Wrenches Under Rs. 10000', href: '/alp/torque-wrenches-under-10000' },
      { label: 'Torque Wrenches Above Rs. 10000', href: '/alp/torque-wrenches-above-10000' },
    ],
  },
  {
    heading: 'Hand Tool Kits',
    links: [
      { label: 'Hand Tool Kits Under Rs. 500', href: '/alp/hand-tool-kits-under-500' },
      { label: 'Hand Tool Kits Under Rs. 1000', href: '/alp/hand-tool-kits-under-1000' },
      { label: 'Hand Tool Kits Under Rs. 5000', href: '/alp/hand-tool-kits-under-5000' },
      { label: 'Hand Tool Kits Above Rs. 10000', href: '/alp/hand-tool-kits-above-10000' },
    ],
  },
  {
    heading: 'Earbuds',
    links: [
      { label: 'Earbuds Under Rs. 1000', href: '/alp/earbuds-under-1000' },
      { label: 'Earbuds Under Rs. 2000', href: '/alp/earbuds-under-2000' },
      { label: 'Earbuds Under Rs. 5000', href: '/alp/earbuds-under-5000' },
      { label: 'Bluetooth Earbuds Under Rs. 1000', href: '/alp/bluetooth-earbuds-under-1000' },
    ],
  },
];

const PopularSearch: React.FC = () => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filtered = useMemo(() => {
    if (!query.trim()) return searchData;
    const lower = query.toLowerCase();
    return searchData
      .map((cat) => ({
        ...cat,
        links: cat.links.filter((l) => l.label.toLowerCase().includes(lower)),
      }))
      .filter(
        (cat) =>
          cat.heading.toLowerCase().includes(lower) || cat.links.length > 0
      );
  }, [query]);

  return (
    <div className="popular-search-page">
      <div className="popular-search-container">
        <div className="popular-search-header">
          <h1>Browse Popular Search Terms</h1>
          <p>Explore trending categories and find exactly what you need</p>
        </div>

        <div className="popular-search-filter">
          <span className="popular-search-filter-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg></span>
          <input
            type="text"
            placeholder="Filter by category or product name..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            id="popular-search-input"
          />
        </div>

        <p className="popular-search-count">
          Showing <span>{filtered.length}</span> categories
        </p>

        {filtered.length > 0 ? (
          <div className="popular-search-grid">
            {filtered.map((cat, idx) => (
              <div key={idx} className="popular-search-card">
                <h2 className="popular-search-card-heading">{cat.heading}</h2>
                <div className="popular-search-links">
                  {cat.links.map((link, lIdx) => (
                    <a key={lIdx} href={link.href} className="popular-search-link">
                      {link.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-results">
            No results found for "<strong>{query}</strong>"
          </div>
        )}
      </div>
    </div>
  );
};

export default PopularSearch;
